// extracted by mini-css-extract-plugin
export const subscribeForm = "subscribe-module--subscribeForm--GfAP9";
export const gumroad = "subscribe-module--gumroad--RXYyj";